/*
 * @Description: enter your description
 * @Autor: zczhang
 * @Date: 2020-07-06 21:43:30
 * @LastEditors: zczhang
 * @LastEditTime: 2020-11-25 15:22:49
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'
import moment from 'moment'
import echarts from 'echarts'
import axios from 'axios'
import qs from 'qs'
import config from './assets/js/config'
import functions from './assets/js/functions'
import global from './assets/js/global'
import dataV from '@jiaminghi/data-view'
import less from 'less'
import BaiduMap from 'vue-baidu-map'
import store from './store'
import { Base64 } from 'js-base64'
import md5 from 'js-md5'

axios.defaults.timeout = 300000
axios.defaults.withCredentials = true
Vue.config.productionTip = false
// Vue.config.devtools = false
Vue.prototype.axios = axios
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts
Vue.prototype.GLOBAL = global
Vue.prototype.CONFIG = config
Vue.prototype.FUNCTIONS = functions
Vue.prototype.$base64 = Base64
Vue.prototype.$md5 = md5

const jswInit = res => {
    //初始化库
    new jSW.SWSession({
        server: '124.70.206.40',
        port: 9701,
        onopen: function(sess) {
            sess.swLogin({
                user: 'admin',
                password: '123456'
            })

            Vue.prototype.jswSession = sess
        }
    })
}
jSW.swInit({
    url: 'http://124.70.206.40:8081', // bv_nginx.exe服务器地址
    calltype: jSW.CallProtoType.AUTO, // AUTO: IE优先使用OCX, 如果希望IE仍然使用HTTP通信, 请使用jSW.CallProtoType.HTTP
    oninit: jswInit
})
Vue.prototype.qs = qs
Vue.use(ElementUI)
Vue.use(dataV)
Vue.use(less)
// Vue.use(BaiduMap, {
//   ak: 'qx5N4OwAw9n5w25LqGKkx2En34ITtqDV'
// })
router.beforeEach((to, from, next) => {
    // next()
    console.log(to.path)
    let userInfo = localStorage.getItem('gcUserInfo')
        ? JSON.parse(localStorage.getItem('gcUserInfo'))
        : ''
    if (to.path === '/') {
        next('/countyControl/index')
    } else {
        next()
    }
    // if (to.path === '/login') {
    //   if (localStorage.getItem('gcUserInfo')) {
    //     next('/');
    //   } else {
    //     localStorage.clear();
    //     next();
    //   }
    // } else {
    //   next()
    // }
})
/* eslint-disable no-new */
new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js